// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

export enum HeaderConstants {
    HEADER_INFO_FRONT_SIZE = 32,
    INFO_GCM_TAG_SIZE = 16,
    IV_SIZE = 16,
    HEADER_INFO_SIZE = HEADER_INFO_FRONT_SIZE + INFO_GCM_TAG_SIZE + IV_SIZE,
    USER_SIZE = 32,
    SECURE_INFO_SIZE = 512,
    SESSION_SIZE = USER_SIZE + SECURE_INFO_SIZE,
    SESSION_GCM_TAG_SIZE = 16,
    MAX_PASSWORDS = 5
}

export class IEncryptionHeaderResponse {
    sessions: number; // the number of sessions encoded in the header
    needMore: boolean; // true if the server needs more to decrypt header
    headerSize: number; // the actual size of the header, this can be used to get the entire header
    isD3E: boolean; // true if header represents a d3e encrypted file
    needsPassword?: boolean; // true if the server requires a password to obtain the kev
    symmetricKey?: string; // The key used to decrypt the file
    iv?: string;  // The iv from the header
    tag?: string;
}

export class IFileStatus {
    ready = false;
    error = false;
    message: string;
    bytesRequired: number;
    headerProcessed = false;
}
